import {computed, observable} from "mobx";
import {IndicadorService} from "../../../services";
import {getMensagemDeErro} from "../../../utils/functions";
import _ from "lodash";

export default class ClassificacaoMediaAlocacaoStore {
    @observable erro;
    @observable carregando;
    @observable dados;

    constructor() {
        this.indicadorService = new IndicadorService();
    }

    filtrar = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.indicadorService.findClassificacaoMediaAlocacao(filtro).then(response => {
            this.dados = response.data.map((cargo) => ({
                nome: cargo.cargo,
                "Média alocação": cargo.mediaAlocacao,
                "Média alocação corrigida": cargo.mediaAlocacaoCorrigida
            }));

            this.carregando = false;
        }).catch(error => {
            this.erro = getMensagemDeErro(error);
            this.carregando = false;
        });
    }

    getQuantidade = (solicitacoes, tipo, prazo) => {
        const solicitacao = _.find(solicitacoes, {
            "tipo": tipo,
            "prazo": prazo
        });

        return solicitacao ? solicitacao.quantidade : 0;
    }
}
